import { Quote } from "lucide-react";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

const testimonials = [
  {
    headline: "The Internal Benchmark for Agile Leadership",
    quote: "Brian is one of those rare leaders who thrives in ambiguity. He leveraged his background in large-scale global operations to bring structure, discipline, and velocity to our Digital Transformation portfolio. He became the internal benchmark for Agile leadership.",
    author: "Jay Sivasailam",
    title: "Chief Growth Officer",
  },
  {
    headline: "Fortune 500 Savvy with Tangible Results",
    quote: "Brian is an exceptional leader who thrives at the intersection of technology, strategy, and innovation. He brings Fortune 500 savvy (Medtronic) alongside nonprofit pragmatism. Organizations who have Brian on their team will see tangible results from his leadership.",
    author: "Dan Ness",
    title: "VP, Chief Marketing & Digital Officer",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1] as const,
    },
  },
};

export const ExecutiveEndorsements = () => {
  return (
    <section
      className="py-16 md:py-24 bg-muted/50"
      aria-labelledby="endorsements-heading"
    >
      <div className="container max-w-6xl mx-auto px-4">
        <motion.h2
          id="endorsements-heading"
          className="text-3xl md:text-4xl font-bold text-center text-foreground mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
        >
          Executive Endorsements
        </motion.h2>

        <motion.div
          className="grid md:grid-cols-2 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {testimonials.map((testimonial, index) => (
            <motion.div key={index} variants={cardVariants}>
              <Card className="bg-background p-8 md:p-10 shadow-card hover:shadow-card-hover transition-shadow duration-300 border-0 h-full">
                <Quote
                  className="w-10 h-10 text-primary mb-6"
                  aria-hidden="true"
                />
                
                <h3 className="font-serif text-xl md:text-2xl font-semibold text-foreground mb-4 italic">
                  "{testimonial.headline}"
                </h3>
                
                <blockquote className="font-serif text-lg md:text-xl text-muted-foreground leading-relaxed mb-8">
                  "{testimonial.quote}"
                </blockquote>
                
                <footer className="border-t border-border pt-6">
                  <p className="font-sans font-bold text-foreground text-lg">
                    {testimonial.author}
                  </p>
                  <p className="font-sans font-semibold text-muted-foreground">
                    {testimonial.title}
                  </p>
                </footer>
              </Card>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};